import '../App.css'
import  './contact.css';
import iconSecton from '../img/icon-section.png';

function Contact() {
    return (
        <div className="contact">
            <section id="contact">
                <img src={iconSecton} alt="icon-section" className='icon-section' />
                <h1>Contact</h1>
            </section>
            <div className='contact-intro'>
                <>科学大生をはじめ、学年・他大学を問わずコミュニティメンバーを募集しています。イベントの共催やコラボレーションも大歓迎です。お気軽にご連絡ください。</>
            </div>
            <div className="contact-buttons">
                <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSfKHp2rNdrMeTqAQxletqC6jAONFGbi3oJ7LuwWJ2uP7Zwbgg/viewform"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="joinus-button-box"
                >
                    <h2>入会希望</h2>
                    <p>科学大生はもちろん、他大学の学生も大歓迎です。学年や専攻に関係なく、スタートアップや起業に興味がある方はぜひご参加ください。</p>
                </a>
                <a
                    href="https://forms.gle/QUoZknHPdkCcBM4p7"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-button-box">
                    <h2>お問い合わせ</h2>
                    <p>勉強会やセミナー、ワークショップなどの共催企画を受け付けています。企業・団体・ゼミや研究室とのコラボもお気軽にご相談ください。運営に関する質問や取材依頼などもこちらからご連絡ください。</p>
                </a>
            </div>
        </div>
    );
}

export default Contact;